var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"points-card-skeleton"},[_c('div',{staticClass:"skeleton-icon"}),_c('div',{staticClass:"skeleton-points-body"},[_c('div',{staticClass:"skeleton-points-number"}),_c('div',{staticClass:"skeleton-points-label"})]),_c('div',{staticClass:"skeleton-convert-btn"})])
}]

export { render, staticRenderFns }